import { httpAuth } from "./http";

export const sendVerificationEmail = (data) =>
  httpAuth.post("/api/firebase/send-verification-email/", data);
